import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
// Import all CSS modules in the same order as parent to ensure consistent webpack ordering
// eslint-disable-next-line no-unused-vars
import _complainStyles from '../complain.module.css';
import styles from './delete.module.css';
// eslint-disable-next-line no-unused-vars
import _statusChangeStyles from './statusChange.module.css';
// eslint-disable-next-line no-unused-vars
import _viewStudentStyles from './viewStudent.module.css';
// eslint-disable-next-line no-unused-vars
import _rejectComplaintStyles from './reject_complaint.module.css';






const DeleteModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className={styles.deleteModal}
    >
      {/* Header */}
      <DialogTitle className={styles.modalHeader}>
        <Typography variant="h6" className={styles.modalTitle}>
          Delete Complaint
        </Typography>
        <IconButton onClick={onClose} className={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent className={styles.modalContent}>
        <Typography variant="body1" className={styles.confirmationText}>
          Are you sure you want to delete this complaint?
        </Typography>
        <Typography variant="body2" className={styles.warningText}>
          This action cannot be undone.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions className={styles.modalActions}>
        <Button
          onClick={onClose}
          variant="outlined"
          className={styles.cancelButton}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          startIcon={
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <path d="M14 4.95833C11.78 4.73833 9.54667 4.625 7.32 4.625C6 4.625 4.68 4.69167 3.36 4.825L2 4.95833" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5.6665 4.28469L5.81317 3.41135C5.91984 2.77802 5.99984 2.30469 7.1265 2.30469H8.87317C9.99984 2.30469 10.0865 2.80469 10.1865 3.41802L10.3332 4.28469" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12.5664 7.06543L12.1331 13.7788C12.0598 14.8254 11.9998 15.6388 10.1398 15.6388H5.85977C3.99977 15.6388 3.93977 14.8254 3.86644 13.7788L3.43311 7.06543" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6.88672 11.9717H9.10672" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6.3335 9.30469H9.66683" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          className={styles.deleteButton}
        >
          Yes, Delete Complaint
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
